import { BrainCircuit, Moon, Sun } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@/components/ui/Tooltip";
import { useTheme } from "@/theme/ThemeProvider";

/** Frame 1 of UI-3 — 56 px, full width, sitting on the sidebar surface. */
export function AppBar({ initials }: { initials: string }) {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();

  return (
    <header className="flex h-14 shrink-0 items-center justify-between bg-[var(--sidebar)] pl-[var(--space-4)] pr-[var(--space-3)]">
      <div className="flex items-center gap-[var(--space-2)]">
        <BrainCircuit size={20} strokeWidth={2} style={{ color: "var(--vl-virtual)" }} />
        <span
          className="vl-wordmark text-[length:var(--text-xl)] font-extrabold tracking-[var(--tracking-snug)]"
        >
          <span className="vl-wordmark-fact">Fact</span><span className="vl-wordmark-orium">orium</span>
        </span>
      </div>

      <div className="flex items-center gap-[var(--space-2)]">
        <Tooltip label={theme === "dark" ? "Switch to the light theme" : "Switch to the dark theme"}>
          <button
            type="button"
            onClick={toggle}
            aria-label={theme === "dark" ? "Switch to the light theme" : "Switch to the dark theme"}
            className="flex h-[26px] w-[30px] items-center justify-center rounded-[var(--radius-md)] text-[var(--text-secondary)] transition-colors duration-[var(--duration-fast)] hover:bg-[var(--sidebar-accent)] hover:text-[var(--text-primary)]"
          >
            {/* Not a theme branch in the styling sense — this control is the one place
                allowed to know the current theme, because toggling it is its whole job. */}
            {theme === "dark" ? <Moon size={15} strokeWidth={2} /> : <Sun size={15} strokeWidth={2} />}
          </button>
        </Tooltip>

        <Tooltip label="Account">
          <button
            type="button"
            onClick={() => navigate("/settings/account")}
            aria-label="Account"
            className="flex h-7 w-7 items-center justify-center rounded-[var(--radius-full)] text-[length:var(--text-2xs)] font-bold text-[var(--text-inverse)] transition-transform duration-[var(--duration-fast)] hover:scale-105"
            style={{ background: "var(--vl-virtual)" }}
          >
            {initials}
          </button>
        </Tooltip>
      </div>
    </header>
  );
}
